// 引入axios方法}
import { fun_PostAction } from "@/api/index";
export default {
  /**
   * 组件默认导出属性
   * @author 滕威
   */
  // 初始化数据
  data() {
    return {
      // 全局加载框
      fullLoading: null,
      // 表单字段
      form: {
        id: null
      },
      // 一览传递的id
      id: null,
      // 用户openId
      openId: null,
      // 详情表单基础数据
      formConfigList: []
    };
  },

  // 模板编译完成
  mounted() {
    // 修改html高度
    document.documentElement.style.height = "100%";
    // 修改body高度
    document.body.style.height = "100%";
    // 获取id
    this.id = this.$route.query.id;
    // 获取项目信息
    this.fun_GetDetails();
  },
  // 自定义事件
  methods: {
    /**
     * 获取项目信息
     * @author liutong
     */
    async fun_GetDetails() {
      let res = await fun_PostAction("/contractRecordDirectly/printDetail", {
        projectId: this.id
      });
      // 解构res.data
      const { result, data, msg } = res.data;
      if (result) {
        // 回显
        this.form = data.model;
        this.fun_GetColumns(data);
      } else {
        // 提示请求失败消息
        this.$message.error(msg);
      }
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(t) {
      this.fullLoading = this.$loading(t);
    },
    /**
     * 获取表单数据
     */
    fun_GetColumns(data) {
      // 详情表单基础数据
      var formConfigList = [
        {
          label: "项目编号",
          value: "constructionNo",
          type: "input",
          required: false,
          disabled: true
        },
        {
          label: "项目名称",
          value: "prjName",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "建设单位",
          value: "buildCorp",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "法人代表",
          value: "corpLegal",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "法人授权委托人",
          value: "linkMan",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "授权委托人电话",
          value: "linkTel",
          type: "input",
          required: false,
          disabled: false
        },
        {
          type: "slot",
          slotName: "projectHead",
          class: "formHead"
        },
        {
          label: "立项批准文号",
          value: "noteNumber",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "工程地点",
          value: "projectSite",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "资金性质",
          value: "fundsCharacter",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "资金来源及落实情况",
          value: "fundsSources",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "房屋建筑工程建筑面积（平方米）",
          value: "constructionArea",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "结构层次",
          value: "structuralHierarchy",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "市政工程规模",
          value: "municipalProjectScale",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "其他工程规模",
          value: "otherProjectScale",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "施工单位",
          value: "constructionUnitName",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "企业资质类别及等级",
          value: "qualificationCategories",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "项目负责人",
          value: "projectManagerName",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "执业资格类别等级及编号",
          value: "qualificationCategoryLevel",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "项目经理安全生产考核合格证书编号",
          value: "managerCertificateNumber",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "专职安全生产管理人员",
          value: "managementCertificateName",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "专职安全生产管理人员安全生产考核合格证书编号",
          value: "managementCertificateNumber",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "计划工程（日历天）",
          value: "planTimeLimit",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "工程造价（万元）",
          value: "projectCost",
          type: "input",
          required: false,
          disabled: false
        },
        {
          label: "发包范围",
          value: "contractScope",
          type: "input",
          required: false,
          disabled: false
        }
      ];
      // 资格预审评审小组成员名单
      formConfigList.push({
        type: "slot",
        slotName: "listHead",
        class: "formHead"
      });
      if (data.list) {
        // 遍历数据
        data.list.map((item, i) => {
          // 职务
          this.$set(this.form, "duty" + i, item.duty);
          // 姓名
          this.$set(this.form, "name" + i, item.name);
          // 职称
          this.$set(this.form, "positionalTitles" + i, item.positionalTitles);
          // 证书名称
          this.$set(this.form, "certificateName" + i, item.certificateName);
          // 级别
          this.$set(this.form, "level" + i, item.level);
          // 证号
          this.$set(this.form, "number" + i, item.number);
          // 专业
          this.$set(this.form, "professional" + i, item.professional);
          var obj = [
            {
              label: "职务",
              value: "duty" + i,
              type: "input",
              required: false,
              disabled: false
            },
            {
              label: "姓名",
              value: "name" + i,
              type: "input",
              required: false,
              disabled: false
            },
            {
              label: "职称",
              value: "positionalTitles" + i,
              type: "input",
              required: false,
              disabled: false
            },
            {
              label: "证书名称",
              value: "certificateName" + i,
              type: "input",
              required: false,
              disabled: false
            },
            {
              label: "级别",
              value: "level" + i,
              type: "input",
              required: false,
              disabled: false
            },
            {
              label: "证号",
              value: "number" + i,
              type: "input",
              required: false,
              disabled: false
            },
            {
              label: "专业",
              value: "professional" + i,
              type: "input",
              required: false,
              disabled: false
            }
          ];
          formConfigList = [...formConfigList, ...obj];
        });
      }
      // 放入集合
      this.formConfigList = formConfigList;
    }
  }
};
